import i18n from 'modules/core/lib/i18n'

export const reviewTypePicker = (type: string) => {
  switch (type) {
    case 'self':
      return i18n.t('performance_process.reviews.review_type_questions_self_review')

    case 'manager':
      return i18n.t('performance_process.reviews.review_type_questions_manager')

    case 'direct_reports':
      return i18n.t('performance_process.reviews.review_type_questions_direct_report')

    case 'peers':
      return i18n.t('performance_process.reviews.review_type_questions_peer')

    default:
      return i18n.t('performance_process.reviews.secondary_title_empty')
  }
}
